export enum IncidentDataSource {
  ELASTIC = 'elastic',
  HUBZH = 'hubzh',
}

export enum ContractService {
  XTENDED = 'XtendedSOC',
  CYBERSOC = 'CyberSOC',
}
